import { useState, useEffect, useCallback } from 'react';
import { RefundsApi } from '@/api/clients/refunds/refunds.api';

export const useGetECheckAuditLogs = (transactionId) => {
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAuditLogs = useCallback(async () => {
    if (!transactionId) {
      setAuditLogs([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await RefundsApi.getECheckAuditLogs(transactionId);
      setAuditLogs(response.data?.data || []);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to load eCheck audit logs';
      setError(errorMessage);
      console.error('Error fetching eCheck audit logs:', err);
    } finally {
      setLoading(false);
    }
  }, [transactionId]);

  useEffect(() => {
    fetchAuditLogs();
  }, [fetchAuditLogs]);

  return {
    auditLogs,
    loading,
    error,
    refetch: fetchAuditLogs,
  };
};
